import React from 'react';
import TopBar from '../global/Top-Bar';
import SideBar from '../global/Side-Bar';
import { Outlet } from 'react-router-dom';
import { useSelector } from 'react-redux';

const HomeDashboard = () => {
	const stat = useSelector(e => e.login);
	console.log("header", stat.profile_status.profile_status)
	return (
		<div className="Dashboard grid grid-cols-auto h-full md:grid-cols-smdash cont:grid-cols-dash grid-rows-dash bg-tet-912 overflow-x-hidden">
			<TopBar topBarShowMenu={true}/>
			<SideBar />
			<Outlet />
		</div>
	);
};

export default HomeDashboard;
